<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="120px"
    />
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
import fieldFilter from '@/utils/fieldFilter.js'
import { TreeDataNull } from '@/utils/tool.js'
export default {
  name: 'Chelianggaojing',
  components: {},
  data() {
    return {
      url: '/alarm/alarmRecord/pageCar',
      columns: [
        {
          label: '终端名称',
          prop: 'connectorName'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel'
        },
        {
          label: '终端编码',
          prop: 'equipmentID'
        },
        {
          label: '归属电站',
          prop: 'stationName'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '告警等级',
          prop: 'alarmLevel'
        },
        {
          label: '告警时间',
          prop: 'createDate'
        },
        {
          label: '短信',
          prop: 'isSendSMS',
          template: (index, record) => {
            return record.isSendSMS ? '是' : '否'
          }
        },
        {
          label: '停充',
          prop: 'isStopCharging',
          template: (index, record) => {
            return record.isStopCharging ? '是' : '否'
          }
        },
        {
          label: '告警原因',
          prop: 'alarmName'
        }
      ],
      // 操作栏
      handles: {
        width: 80,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'alarm.car.details',
            handle: resp => {
              this.$router.push({ path: './vehicleAlarmDetail', query: { data: resp.id }})
            }
          }
        ]
      },
      query: [
        {
          label: '终端名称',
          prop: 'connectorName',
          placeholder: '请输入终端名称 '
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel',
          type: 'cascader',
          data: [],
          props: {
            label: 'name',
            value: 'id',
            checkStrictly: true
          },
          placeholder: '请选择品牌型号'
        },
        {
          label: '终端编码',
          prop: 'connectorID',
          placeholder: '请输入终端编码'
        },
        {
          label: '归属电站',
          prop: 'stationName',
          placeholder: '请输入归属电站'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq',
          placeholder: '请输入充电单号'
        },
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '告警等级',
          prop: 'alarmLevel',
          placeholder: '请选择告警等级',
          type: 'select',
          data: [
            {
              label: '一级',
              value: 1
            },
            {
              label: '二级',
              value: 2
            },
            {
              label: '三级',
              value: 3
            }
          ]
        },
        {
          label: '告警原因',
          prop: 'alarmType',
          placeholder: '请选择告警原因',
          type: 'select',
          data: [
            {
              label: 'SOC过充',
              value: 0
            },
            {
              label: '电池电量过充',
              value: 1
            },
            {
              label: '电池温度过高',
              value: 2
            }
          ]
        },
        {
          label: '短信通知',
          prop: 'isSendSMS',
          placeholder: '请选择短信通知',
          type: 'select',
          data: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        },
        {
          label: '是否停充',
          prop: 'isStopCharging',
          placeholder: '请选择是否停充',
          type: 'select',
          data: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        },
        {
          label: '告警时间',
          prop: 'operatorCode',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          permission: 'alarm.car.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/alarm/alarmRecord/pageCar?isExport=true'
            const queryData = this.$refs.tableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'get',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.$store.dispatch('form/handle', {
      url: '/station/equipment/getBrandTree',
      method: 'get',
      callback: (resp) => {
        if (resp && resp.length > 0) {
          this.query[1].data = TreeDataNull(resp)
        }
      }
    })
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/vehicleAlarm.vue